<template>
  <div class="type-box">
    <el-row class="first-img"></el-row>
    <div v-for="(item, index) in goodList">
      <el-row :key="index">
        <el-col :span="12">
          <div>
            <el-image
              class="type-img"
              @click="goDetail(item[0].typeId,item[0].modulePrpty)"
              :src="
                'data:image/' + item[0].imgType + ';base64,' + item[0].imgUrl
              "
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-col>
        <el-col :span="12" v-if="item.length > 1">
          <div>
            <el-image
              class="type-img"
              @click="goDetail(item[1].typeId)"
              :src="
                'data:image/' + item[1].imgType + ';base64,' + item[1].imgUrl
              "
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { formatDate } from "@api/date.js";
export default {
  name: "ClassChannelList",
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      url: "@assets/images/classChannel/3.jpg"
    };
  },
  methods: {
    // 商品详情跳转
    goDetail(key,modulePrpty) {
      console.log("modulePrpty类型:"+modulePrpty);
      this.$router.push({ name: "GoodsType", params: { typeId: key,modulePrpty:modulePrpty } });
    }
  },
  filters: {
    formatDateDay(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    }
  }
};
</script>

<style>
.lesson-text-line1 {
  text-align: left;
  margin-top: 1vh;
  font-size: 12px;
  margin-left: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type-box {
  /*margin-left: 0vw;*/
  /*margin-right: 0vw;*/
  margin-top: 2vh;
  /*padding: 1px;*/
}

.type-img {
  margin-left: 2vw;
  margin-right: 2vw;
  margin-top: 1vh;
  width: 92%;
  border-radius: 5px;
  text-align: center;
}

.el-row-out {
  /*height: 16.5vh;*/
  margin: 1vh;
  border: 2px solid white;
  border-radius: 8px;
  /*padding: 1vw;*/
}

.el-row-in {
  margin-bottom: 5vh;
}

.lesson-tag {
  margin-left: 1vw;
  width: 90%;
  border-radius: 30px;
}

.first-img {
  height: 7vh;
  width: 100%;
  position: relative;
  text-align: center;
  background-size: 100% 100%; /*按比例缩放*/
  background-image: url("../assets/images/classChannel/xdts.png");
}
</style>
